import React, { useState } from 'react';
import { Image } from '../Image';
import { RichH4, RichP1 } from '../Typography';
import styled from 'styled-components';
import media from '../../utils/media';
import { CTALink } from '../Link';
import { isFieldValid } from '../../utils/validation';
import { VideoThumbnail, VideoLightbox } from '../Video';
import { getParsedField } from '../../utils/helpers';
import { populateCTAGTM } from '../../utils/gtm';
const ContentContainer = styled.div `
  overflow-wrap: break-word;
  padding-left: 30px;
  padding-right: 30px;
  ${media.mobile} {
    padding-left: 20px;
    padding-right: 20px;
  }
`;
const ImageContainer = styled.div `
  position: relative;
  height: 230px;
  ${media.mobileL} {
    height: 190px;
  }
`;
const CardImage = styled(Image) `
  width: 100%;
  height: 100%;
`;
const LogoImage = styled(Image) `
  background: ${({ theme }) => theme.primaryWhite};
  height: 100px;
  width: 100px;
  position: absolute;
  bottom: 0;
  margin-left: 30px;
  object-fit: contain;
  ${media.mobile} {
    margin-left: 20px;
    height: 75px;
    width: 75px;
  }
`;
const ContentTitleCotainer = styled.div `
  margin-top: 40px;
`;
const ContentBody = styled(RichP1) `
  margin: 10px 0 25px 0;
`;
const LinkContainer = styled.div `
  margin-bottom: 33px;
`;
const Link = styled(CTALink) `
  font-size: 22px;
  line-height: 23px;
`;
export const CardGridItem = ({ fields }) => {
    if (!fields) {
        console.warn('CardGridItem component requires fields to be provided');
        return null;
    }
    const [isVideoOpen, setIsVideoOpen] = useState(false);
    const { contentTitle, contentBodyText, thumbnailImage, logoImage, videoUrl, ctaType, ctaLink, ctaLinkText, } = fields;
    const parsedTitle = getParsedField(contentTitle);
    const parsedBodyText = getParsedField(contentBodyText);
    let media = thumbnailImage;
    let video = videoUrl;
    return (React.createElement(React.Fragment, null,
        React.createElement(VideoLightbox, { isOpen: isVideoOpen, onClose: () => setIsVideoOpen(false), closeIconLabel: 'Close Lightbox', videoLabel: 'Video', video: video, videoHeight: 70, isContained: false }),
        React.createElement(ImageContainer, null,
            isFieldValid(media) && !isFieldValid(video, 'href') && (React.createElement(CardImage, { media: media, width: null, height: null })),
            isFieldValid(video, 'href') && (React.createElement(VideoThumbnail, { media: media, onPlay: () => setIsVideoOpen(true) })),
            isFieldValid(logoImage) && React.createElement(LogoImage, { media: logoImage, width: null, height: null })),
        React.createElement(ContentContainer, null,
            isFieldValid(contentTitle) && (React.createElement(ContentTitleCotainer, null,
                React.createElement(RichH4, { field: parsedTitle }))),
            isFieldValid(contentBodyText) && React.createElement(ContentBody, { field: parsedBodyText }),
            isFieldValid(ctaLink) && (React.createElement(LinkContainer, null,
                React.createElement(Link, Object.assign({ field: ctaLink, textField: ctaLinkText, typeField: ctaType }, populateCTAGTM(fields))))))));
};
export default CardGridItem;
